import React from 'react'

import {Registry} from './utils'

export class PartRegistry extends Registry {
  // return created react element from component with minimal part config
  createElement = (name, ...cfg) =>
    this.get(name) ? React.createElement(this.get(name), {type: name, ...cfg}) : `missing ${name}`
}

// setup connected versions of Part-React.Components
export const Parts = new PartRegistry({
  namespace: 'Part',
  connect: true,
  components: {},
})

// more
export const WikiTemplates = {}
export const JobTemplates = {} // greppable name
export const DashboardPanels = {}
